// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teacher-information-block{
  margin-bottom: 50px ;
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  border-radius: 12px;
  background-color: #eeeeee;
}

.teacher-block-img{
  margin-right: 15px;
  width: 100px;
  height: 100px;
}

@media screen  and (max-width: 520px) {
  .teacher-information-block {
    margin-top: 15px;
    margin-bottom: 0;
    width: 85%;
  }
  .teacher-block-img{
    width: 80px;
    height: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Schedule/TeacherSchedule/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".teacher-information-block{\n  margin-bottom: 50px ;\n  padding: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  border-radius: 12px;\n  background-color: #eeeeee;\n}\n\n.teacher-block-img{\n  margin-right: 15px;\n  width: 100px;\n  height: 100px;\n}\n\n@media screen  and (max-width: 520px) {\n  .teacher-information-block {\n    margin-top: 15px;\n    margin-bottom: 0;\n    width: 85%;\n  }\n  .teacher-block-img{\n    width: 80px;\n    height: 80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
